import PDF from '../../components/PDF/Report-Pdf';

const AssessmentResult = () => {
  const resultId = new URLSearchParams(window.location.search).get('resultId');
  return (
    <PDF id={resultId || ''} />
  );
};

export default AssessmentResult;
